import * as React from "react";
import logo from "@/assets/images/logo.png";
import { NavUser } from "@/components/nav-user";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
} from "@/components/ui/sidebar";
import { SidebarContentProps } from "@/types/index.type";
import { renderSidebarItem } from "@/utils/renderSidebarItem";
import { CompanyLogo } from "@/components/company-logo";
import ResetMyPassowrd from "@/views/authentication/components/ResetMyPassowrd";
import { useState } from "react";
import { User } from "@/views/modules/user-management/users/types/userType";

const company = {
  name: "Child Smile",
  fullLogo: logo,
  logo: logo,
};
const RAppSidebar = ({
  contentData,
  user,
  ...props
}: React.ComponentProps<typeof Sidebar> & {
  contentData: SidebarContentProps[];
  user: User | null;
}) => {
  const isRTL = document.dir === 'rtl';
  const [isResetOpen, setIsResetOpen] = useState<boolean>(false);

  return (
    <Sidebar
      collapsible="icon"
      variant="sidebar"
      className="h-full shadow-lg"
      side={isRTL ? "right" : "left"}
      {...props}
    >
      <SidebarHeader>
        <CompanyLogo company={company} />
      </SidebarHeader>
      <SidebarContent style={{ scrollbarWidth: "none" }}>
        {contentData.map((content) => {
          return renderSidebarItem(content.item);
        })}
      </SidebarContent>
      <SidebarFooter className="border-t">
        <NavUser user={user} handleIsResetOpen={setIsResetOpen} />
        <ResetMyPassowrd isResetOpen={isResetOpen} handleIsResetOpen={setIsResetOpen} />
      </SidebarFooter>
    </Sidebar>
  );
};

export default RAppSidebar;
